import { render, staticRenderFns } from "./PageEditorSectionDeleteBtn.vue?vue&type=template&id=731b2578&scoped=true"
import script from "./PageEditorSectionDeleteBtn.vue?vue&type=script&lang=js"
export * from "./PageEditorSectionDeleteBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731b2578",
  null
  
)

export default component.exports